export default __webpack_public_path__ + "static/media/info.bf7f5fcf.svg";